import React from 'react';
import './TwoCategory.scss';
import LazyLoadBackgroundImage from '../../../CommonComponents/LazyLoadBackgroundImage/LazyLoadBackgroundImage';

const TwoCategory = ({ categories }) => {
  const handleCategoryClick = (title, src) => {
    // OD__CLEVERTAP__EVENT (cta_click)
    window.location.assign(src);
  };

  if (categories.length > 0) {
    return (
      <div className="od-two-category-home">
        {categories.map((category, idx) => {
          return (
            <LazyLoadBackgroundImage
              key={idx}
              className="od-two-category-home__content"
              src={category.img.src}
              style={{
                backgroundColor: category.backgroundColor,
              }}
            >
              {category?.offerText ? (
                <div className="od-two-category-home__content__offer">{category?.offerText}</div>
              ) : null}
              <div
                className="od-two-category-home__content__inner"
                onClick={() => handleCategoryClick(category.explore.title, category.explore.src)}
              >
                {category.subText ? (
                  <div className="od-two-category-home__content__inner__subtext">
                    {category.subText}
                  </div>
                ) : null}
                <h3 className="od-two-category-home__content__inner__title">{category.title}</h3>
                <button className="owndays-btn owndays-btn--secondary">
                  {category?.explore?.title}
                </button>
              </div>
            </LazyLoadBackgroundImage>
          );
        })}
      </div>
    );
  }

  return null;
};

export default TwoCategory;
